import { api } from "@/lib/apiClient";

const KEY = "astra_creator_token";
export const SITE = "https://astralogico.com";
export const creatorToken = () => localStorage.getItem(KEY) || "";
export const setCreatorToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));
export const creatorApi = (method, url, data, extra = {}) =>
  api.request({ method, url, data, ...extra, headers: { ...(extra.headers || {}), "X-Creator-Token": creatorToken() } });

export const NICHES = [
  ["genz_mystic", "Gen Z Mystic"], ["wellness", "Wellness & self-care"], ["parenting", "Mum & family life"],
  ["career", "Career & ambition"], ["wise_guide", "Wise guide"], ["other", "Something else"],
];
export const PLATFORMS = ["Instagram", "TikTok", "YouTube", "Facebook", "Threads", "Pinterest", "Newsletter", "Blog", "Other"];
export const DISCLOSURE = "#ad I may earn a commission if you buy through my Astra link.";
export const money = (n, cur = "gbp") =>
  new Intl.NumberFormat(undefined, { style: "currency", currency: cur.toUpperCase() }).format(n || 0);

export const inputCls = "w-full bg-[#0B0F19] border border-[#D4AF37]/25 rounded-xl px-4 py-3 text-starlight outline-none focus:border-[#D4AF37] transition-colors";
export const cardCls = "bg-[#0F1523] border border-[#D4AF37]/20 rounded-2xl p-5";
export const btnGold = "bg-[#D4AF37] hover:bg-[#e6c04e] text-[#04060B] font-medium rounded-full transition-colors disabled:opacity-60";
